import { LayoutList, SlidersHorizontal } from 'lucide-react';
import { ADMIN_GUARD } from '../admin-guard';
import { CONTEXTS, lazyView, type FeatureManifest } from '@/app/registry';
import { adminSkillsRoutes } from './routes';
import { SKILL_LEVEL_EDIT_TAB } from './skillPanels';

export const adminSkillsManifest: FeatureManifest = {
  id: 'admin-skills',
  contexts: [CONTEXTS.ADMIN_SKILLS, CONTEXTS.ADMIN_SKILL_FORM],

  routes: [{ routes: adminSkillsRoutes, errorFallbackLabel: 'Compétences', guard: ADMIN_GUARD }],

  centerView: {
    [CONTEXTS.ADMIN_SKILLS]: lazyView(
      () => import('../views/AdminSkillsListView'),
      'AdminSkillsListView',
    ),
    [CONTEXTS.ADMIN_SKILL_FORM]: lazyView(
      () => import('../views/AdminSkillFormView'),
      'AdminSkillFormView',
    ),
  },

  panels: {
    left: {
      tabs: {
        [CONTEXTS.ADMIN_SKILLS]: [
          {
            id: 'admin-nav',
            label: 'Navigation',
            icon: LayoutList,
            view: lazyView(() => import('../views/AdminNavView'), 'AdminNavView'),
          },
        ],
        [CONTEXTS.ADMIN_SKILL_FORM]: [
          {
            id: 'admin-nav',
            label: 'Navigation',
            icon: LayoutList,
            view: lazyView(() => import('../views/AdminNavView'), 'AdminNavView'),
          },
        ],
      },
    },
    right: {
      tabs: {
        [CONTEXTS.ADMIN_SKILL_FORM]: [
          {
            id: SKILL_LEVEL_EDIT_TAB,
            label: 'Palier',
            icon: SlidersHorizontal,
            view: lazyView(
              () => import('../views/AdminSkillLevelEditView'),
              'AdminSkillLevelEditView',
            ),
          },
        ],
      },
    },
  },

  enabledWhen: {
    roles: ['admin'],
  },

  panelRequirements: {
    [CONTEXTS.ADMIN_SKILLS]: {
      left: { open: true, defaultActiveTab: 'admin-nav' },
      right: { open: false },
    },
    [CONTEXTS.ADMIN_SKILL_FORM]: {
      left: { open: true, defaultActiveTab: 'admin-nav' },
      // Fermé par défaut : ouvert uniquement pendant l'ajout/édition d'un palier
      // (piloté par le draft dans AdminSkillFormView).
      right: { open: false, defaultActiveTab: SKILL_LEVEL_EDIT_TAB },
    },
  },
};
